export const IMAGE_TYPE = {
  BLEND: 'blend',
  COLOR: 'color',
  COLORREF: 'colorref'
}

export const createMapIcon = (
  label,
  size = 25,
  baseFontSize = 12,
  fill = 'red',
  stroke = 'white',
  strokeWidth = 2,
  textFill = 'white'
) => {
  if (label === undefined || label === null) {
    return ''
  }
  const fontSize = baseFontSize * (1 - (label.length - 1) * 0.2)
  // prettier-ignore
  const svg = `
    <svg xmlns="http://www.w3.org/2000/svg" width="${size}" height="${size}" viewBox="0 0 ${size} ${size}">
      <circle cx="${size / 2}" cy="${size / 2}" r="${size / 2 - 2}" fill="${fill}" stroke="${stroke}" stroke-width="${strokeWidth}" />
      <text
        x="52%"
        y="52%"
        font-size="${fontSize}"
        font-weight="bold"
        text-anchor="middle"
        dominant-baseline="middle"
        fill="${textFill}"
        font-family="Arial, sans-serif"
      >${label}</text>
    </svg>
  `
  return `data:image/svg+xml;base64,${btoa(svg)}`
}
